import React from 'react'
import { RouterApp } from './router/RouterApp'

export const PagoWebApp = () => {
  return (
    <>
      <RouterApp />    
    </>
  )
}
